module.exports = __webpack_public_path__ + "img/bowls_n.7fc9f23e.png";